<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" >
      <b-col cols="12">
        <b-form inline>
          <b-form-input
            style="min-width:150px;"
            class="m-1"
            placeholder="机构名称"
            v-model="queryParam.criteria.keywords"
          ></b-form-input>

          <b-button variant="outline-primary" @click="handleQuery" class="m-1">查询</b-button>
        </b-form>
      </b-col>
    </b-row>

    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(serviceCheckPrice)="data">
          {{data.item.serviceCheckPrice +'('+data.item.serviceCheckPeriod + "个月)"}}
        </template>

        <template v-slot:cell(actions)="row">
          <b-link @click="showManualRechargeDialog(row.item.id)" class="mr-3">充值</b-link>
          <b-link @click="showPriceSettingDialog(row.item)">价格</b-link>
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>   

    <!-- 显示手工充值对话框 -->
    <b-modal
      id="manualRechargeModal"
      title="手工充值"
      incline
      v-model="manualRechargeDialogVisible"
      @ok="handleManualRecharge"
    >
      <template slot="modal-ok">充值</template>
      <template slot="modal-cancel">取消</template>

      <form>
        <validation-observer ref="manualRechargeForm">
          <validation-provider
              :rules="{required:true, numeric:true}"
              name="充值金额"
              v-slot="validationContext"
              >
            <b-form-group label="充值金额" label-cols="3" label-align="right" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                v-model="rechargeDto.amount" 
                :state="validateState(validationContext)"
                placeholder="请输入充值金额">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="{}"
              name="虚拟充值"
              v-slot="validationContext"
              >

            <b-form-group label="" label-cols="3" label-align="right" :invalid-feedback="validationContext.errors[0]">
              <b-form-checkbox
                id="checkbox-1"
                v-model="rechargeDto.virtual"
                :state="validateState(validationContext)"
                value="true"
                unchecked-value="false"
              >虚拟充值
              </b-form-checkbox>
            </b-form-group>
          </validation-provider>

        </validation-observer>
      </form>
    </b-modal>

    <!-- 显示价格设置对话框 -->
    <b-modal
      id="priceSettingModal"
      title="价格设置"
      incline
      v-model="priceSettingDialogVisible"
      @ok="handlePriceSetting"
    >
      <template slot="modal-ok">确定</template>
      <template slot="modal-cancel">取消</template>

      <form>
        <validation-observer ref="priceSettingForm">
          <validation-provider
              :rules="{required:true, min_value:1, integer:true}"
              name="计费周期"
              v-slot="validationContext"
              >
            <b-form-group label="计费周期(月）" label-cols="5" label-align="right" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                v-model="priceDto.serviceCheckPeriod" 
                :state="validateState(validationContext)"
                placeholder="服务费计费周期">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="{required:true, numeric:true}"
              name="服务费"
              v-slot="validationContext"
              >
            <b-form-group label="服务费（元/周期）" label-cols="5" label-align="right" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                v-model="priceDto.serviceCheckPrice" 
                :state="validateState(validationContext)"
                placeholder="元">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="{required:true, min_value:0.15}"
              name="OCR费用"
              v-slot="validationContext"
              >
            <b-form-group label="OCR费用(元/次）" label-cols="5" label-align="right" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                v-model="priceDto.ocrPrice" 
                :state="validateState(validationContext)"
                placeholder="(元/次）">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="{required:true, min_value:0.1}"
              name="查验费用"
              v-slot="validationContext"
              >
            <b-form-group label="查验费用(元/次）" label-cols="5" label-align="right" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                v-model="priceDto.verifyPrice" 
                :state="validateState(validationContext)"
                placeholder="元">
              </b-form-input>
            </b-form-group>
          </validation-provider>


        </validation-observer>
      </form>
    </b-modal>

  </div>
</template>

<script>
import * as orgFinFacade from "../../../api/orgfin-facade.js";
import * as transFacade from "../../../api/trans-facade.js";

export default {
  // validations:
  data() {
    return {
      rechargeDto:{},
      priceDto:{},
      fields: [
        {
          key: "orgName",
          label: "机构名称"
        },
        {
          key: "balanceAmount",
          label: "余额"
        },
        {
          key: "serviceCheckPrice",
          label: "查验服务费"
        },
        {
          key: "verifyPrice",
          label: "查验价格(元/条)"
        },
        {
          key: "ocrPrice",
          label: "OCR价格(元/条)"
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],
      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          keywords: "",
        },
        sortOrder: { createTime: "descending" }
      },
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      manualRechargeDialogVisible: false,
      priceSettingDialogVisible: false,
    }
  },

  created() {},
  mounted() {
    // 异步加载列表数据
    this.handleQuery();

  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    // 异步加载列表数据
    list(page) {
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      orgFinFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    handleQuery(){
      this.list()
    },
    //
    showManualRechargeDialog(value){
      let that = this;
      that.rechargeDto= {orgId: value, virtual: true, amount:0}
      this.manualRechargeDialogVisible = true
    },
    // 执行充值
    handleManualRecharge(e){
      // 调用手工审核的方法
      e.preventDefault();

      //this.nameState = this.$refs.form.checkValidity();
      this.$refs.manualRechargeForm.validate().then(success => {
        if (!success) {
          return;
        }
        // 执行人工审核操作
        this.pageLoading = true;
        transFacade
          .recharge(this.rechargeDto)
          .then(res => {
            this.pageLoading = false;
            this.rechargeDto = res;
            this.$message({
              message: "人工充值处理成功",
              type: "success"
            });
            this.list();
          })
          .catch(err => {
            this.pageLoading = false;
            console.log("err", err);
          });
          this.manualRechargeDialogVisible = false
      })
    },

    // 显示价格设置
    showPriceSettingDialog(val){
      let that = this;
      that.priceDto= {
        orgId: val.id, 
        serviceCheckPrice: val.serviceCheckPrice, 
        serviceCheckPeriod: val.serviceCheckPeriod,
        verifyPrice: val.verifyPrice,
        ocrPrice: val.ocrPrice,
        }
      this.priceSettingDialogVisible = true
    },

    handlePriceSetting(e){
      e.preventDefault();

      //this.nameState = this.$refs.form.checkValidity();
      this.$refs.priceSettingForm.validate().then(success => {
        if (!success) {
          return;
        }
        // 执行人工审核操作
        this.pageLoading = true;
        orgFinFacade
          .priceSetting(this.priceDto)
          .then(res => {
            this.pageLoading = false;
            this.rechargeDto = res;
            this.$message({
              message: "设置价格成功",
              type: "success"
            });
            this.list();
          })
          .catch(err => {
            this.pageLoading = false;
            console.log("err", err);
          });
          this.priceSettingDialogVisible = false
      })

    },
}
};
</script>

<style >
</style>
